import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_STARTER_DM_RECOMMENDER = defineFcm('starfish_starter_dm_recommender')
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Starter Dashboard page',
		description: 'Feature release flag that enables decision maker recommendations on the starter dashboard',
		mergeLogic:
			'Checks `locale` and `countryCode` to determine value. Both must be `true` for the feature to be enabled',
		import: false,
	});
